// Basic links Tracking
initTracking();

function initTracking() {
    initBasicLinksTracking();
    initRolexMapTracking();
    initContactFormTracking();
    initTrackingBasingOnAnEvent("rolex-map-loaded");
    initDownloadTracking();
}

function initBasicLinksTracking() {
    let findStoreNewTab = true;
    if(document.querySelectorAll('body.template-product').length > 0) {
        findStoreNewTab = false;
    }

    var targets = [
        [ document.querySelectorAll('a.rolex-findstore-tracking'), 'findStore', findStoreNewTab],
        [ document.querySelectorAll('a.rolex-contactCall-tracking'), 'contactCall', false],
        [ document.querySelectorAll('a.rolex-getdirection-tracking'), 'getDirections', true]
    ];

    targets.forEach(function(elementsToTrack) {
        elementsToTrack[0].forEach(function(element) {
            setTrackingEventOnClick(element, elementsToTrack[1], elementsToTrack[2]);
        });
    });
}

function initRolexMapTracking(){
    $(document).on('rolex-map-loaded', function() {
        var targets = [
            [ document.querySelectorAll('.maps-popup-content a.rolex-findstore-tracking'), 'findStore', true],
            [ document.querySelectorAll('.maps-popup-content a.rolex-contactCall-tracking'), 'contactCall', false]
        ];

        targets.forEach(function(elementsToTrack) {
            elementsToTrack[0].forEach(function(element) {
                setTrackingEventOnClick(element, elementsToTrack[1], elementsToTrack[2]);
            });
        });
    });
}

function initContactFormTracking() {
    $(document).on("rolex-contact-send", function () {
        _satellite.track("contactForm");
    });
}

function initTrackingBasingOnAnEvent(triggeredEvent) {
    document.addEventListener(triggeredEvent, function(e) {
        switch (triggeredEvent){
            case "rolex-map-loaded":
                setTrackingEventOnClick(document.getElementById('showStore').querySelector('a.rolex-getdirection-tracking'), 'getDirections', true);
                break;
        }
    });
}

function setTrackingEventOnClick(targetElement, trackingEvent, newTab = false) {
    if(targetElement){
        targetElement.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            _satellite.track(trackingEvent);
            console.log('tracking event: ' + trackingEvent);

            if(newTab) {
                window.open(targetElement.href, '_blank');
            } else {
                window.location.assign(targetElement.href);
            }
        });
    }
}

function initDownloadTracking() {
    window.addEventListener("load", function() {
        var downloadButton = document.getElementById('download-model-brochure');
        if (downloadButton) {
            downloadButton.addEventListener('click', function(e) {
                _satellite.track('download');
            });
        }
    });
}